import apiClient from './client';

export interface DashboardStats {
  servers: {
    total: number;
  };
  apps: {
    total: number;
    active: number;
    inactive: number;
    deploying: number;
    failed: number;
  };
  domains: {
    total: number;
  };
  deployments: {
    last_7_days: number;
  };
  terminal_sessions: {
    active: number;
  };
  users: {
    total: number;
  };
}

export interface RecentDeployment {
  id: string;
  app_id: string;
  app_name: string;
  version: string;
  status: string;
  created_at: string;
}

export interface AppStatusItem {
  id: string;
  name: string;
  slug: string;
  status: string;
  server_name: string;
  domain: string | null;
  updated_at: string;
}

export interface ServerHealth {
  id: string;
  name: string;
  host: string;
  status: 'online' | 'offline';
  uptime?: string;
  load_average?: string;
  memory_usage?: string;
  disk_usage?: string;
  error?: string;
}

export interface ActivityItem {
  id: string;
  user_id: string | null;
  action: string;
  resource_type: string;
  resource_id: string | null;
  details: Record<string, unknown> | null;
  created_at: string;
}

export const dashboardApi = {
  getStats: async (): Promise<DashboardStats> => {
    const response = await apiClient.get<DashboardStats>('/api/v1/dashboard/stats');
    return response.data;
  },

  getRecentDeployments: async (limit: number = 10): Promise<RecentDeployment[]> => {
    const response = await apiClient.get<RecentDeployment[]>('/api/v1/dashboard/deployments/recent', {
      params: { limit },
    });
    return response.data;
  },

  getAppsStatus: async (): Promise<AppStatusItem[]> => {
    const response = await apiClient.get<AppStatusItem[]>('/api/v1/dashboard/apps/status');
    return response.data;
  },

  getServersHealth: async (): Promise<ServerHealth[]> => {
    const response = await apiClient.get<ServerHealth[]>('/api/v1/dashboard/servers/health');
    return response.data;
  },

  getActivity: async (limit: number = 20): Promise<ActivityItem[]> => {
    const response = await apiClient.get<ActivityItem[]>('/api/v1/dashboard/activity', {
      params: { limit },
    });
    return response.data;
  },
};
